import { Controller } from "@hotwired/stimulus";

// Appends the value picked in the select to a comma separated list in a textarea.
export default class extends Controller {
  static targets = ["select", "list"];

  add(event) {
    event.preventDefault();
    const value = this.selectTarget.value;
    if (!value) return;
    const list = this.listTarget;
    list.value = list.value.length > 0 ? `${list.value}, ${value}` : value;
  }
}
